import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";

export const getCampaignStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: "Lưu tạm",
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: "Đang xử lý upload",
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: "Hoàn tất upload",
      badgeColor: "badge-soft-success",
    },
    [AUTH_STATUS_REJECT]: {
      text: "Lỗi",
      badgeColor: "badge-soft-danger",
    },
    [AUTH_STATUS_AR]: {
      text: "Validate hoàn tất",
      badgeColor: "badge-soft-info",
    },
    [AUTH_STATUS_WARNING]: {
      text: "Cảnh báo",
      badgeColor: "badge-soft-warning",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const TYPE_REPORT = {
  ERROR: "ERROR",
};

export const SELECT_FILTER_TYPE = {
  1: "Hóa đơn GTGT",
  //   2: "Hóa đơn BH",
  //   3: "Tem phiếu",
  //   4: "Phiếu xuất kho nội bộ",
  //   5: "Phiếu xuất kho bán đại lý",
};
